(function () {
  const bar = document.getElementById('sticky-atc');
  if (!bar) return;

  const sectionId = bar.dataset.sectionId;
  const mainForm = document.getElementById(`product-form-${sectionId}`);
  if (!mainForm) return;

  const mainBtn = mainForm.querySelector('[name="add"]');
  const mainBtnText = mainForm.querySelector('[name="add"] staged-action-text');
  const mainBtnContainer = mainForm.querySelector('.js-product-buttons');
  const stickyBtn = document.getElementById('sticky-atc-btn');
  const stickyBtnText = stickyBtn.querySelector('.sticky-atc__btn-text');
  const stickyStagedAction = stickyBtn.querySelector('staged-action');

  // --- Scroll trigger ---
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  let userHasScrolled = false;
  let atcIsVisible = true;

  const observer = new IntersectionObserver(
    ([entry]) => {
      atcIsVisible = entry.isIntersecting;

      if (!isMobile || userHasScrolled) {
        bar.classList.toggle('sticky-atc--hidden', atcIsVisible);
        bar.setAttribute('aria-hidden', String(atcIsVisible));
      }
    },
    { threshold: 0, rootMargin: '0px 0px -20px 0px' }
  );

  observer.observe(mainBtnContainer);

  if (isMobile) {
    window.addEventListener('scroll', () => {
      if (!userHasScrolled) {
        userHasScrolled = true;
        bar.classList.toggle('sticky-atc--hidden', atcIsVisible);
        bar.setAttribute('aria-hidden', String(atcIsVisible));
      }
    }, { passive: true });
  }

  // --- Sync disabled/text state ---
  function syncState() {
    const isDisabled = mainBtn.disabled || mainBtnContainer.classList.contains('is-disabled');
    stickyBtn.disabled = isDisabled;
    stickyBtn.classList.toggle('is-disabled', isDisabled);
    if (mainBtnText) {
      stickyBtnText.textContent = mainBtnText.textContent.trim();
    }
  }

  new MutationObserver(syncState).observe(mainBtn, { attributes: true });
  new MutationObserver(syncState).observe(mainBtnContainer, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('variant:changed', syncState);
  syncState();

  // --- Mirror staged-action animation ---
  const mainStagedAction = mainBtn.querySelector('staged-action');

  if (mainStagedAction && stickyStagedAction) {
    new MutationObserver(() => {
      const isDoing = mainStagedAction.classList.contains('is-doing');
      const isDone = mainStagedAction.classList.contains('is-done');
      stickyStagedAction.classList.toggle('is-doing', isDoing);
      stickyStagedAction.classList.toggle('is-done', isDone);
    }).observe(mainStagedAction, { attributes: true, attributeFilter: ['class'] });
  }

  // --- Delegate click to the real button ---
  stickyBtn.addEventListener('click', () => {
    if (!mainBtn.disabled) {
      mainBtn.click();
    }
  });
})();